import { render, staticRenderFns } from "./ClipboardTool.vue?vue&type=template&id=e612b1ca&scoped=true&"
import script from "./ClipboardTool.vue?vue&type=script&lang=ts&"
export * from "./ClipboardTool.vue?vue&type=script&lang=ts&"
import style0 from "./ClipboardTool.vue?vue&type=style&index=0&id=e612b1ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e612b1ca",
  null
  
)

export default component.exports